import { buildValidator } from "./buildValidator";

export const selectValueIsTruthy = buildValidator("invalid", (value) => (value as string[]).every(Boolean));
